import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';

import HomePage from './page/home/HomePage';
import FlightsPage from './page/flights/FlightsPage';
import FlightsSearchPage from './page/flightsSearch/FlightsSearchPage';
import PassengersPage from './page/passengers/PassengersPage';
import CheckoutPage from './page/checkout/CheckoutPage';
import ResumePage from './page/resume/ResumePage';
import TudoAzulPage from './page/tudoAzulPage/TudoAzulPage';
import HeaderContainer from './components/header/headerContainer/HeaderContainer';

import './RootPage.css';
import FlightChangeSearchPage from './page/flightChangeSearch/FlightChangeSearchPage';
import FlightDetailsPage from './page/flightDetailsPage/FlightDetailsPage';
import SearchResultPage from './page/searchResultPage/SearchResultPage';
import PaymentChangePage from './page/paymentChange/PaymentChangePage';
import FlightChangePage from './page/flightChange/FlightChangePage';
import FlightChangeSelection from './page/flightChangeSelection/FlightChangeSelection';
import CancelPnrPage from './page/cancelPnr/CancelPnrPage';
import PaymentCancelPage from './page/cancelPnr/components/paymentCancel/PaymentCancelPage';

const propTypes = {
  headerComponentEnabled: PropTypes.bool
};

const defaultProps = {
  headerComponentEnabled: false
};

const regexProps = {
  numeric: '([0-9-]+)',
  alpha: '([a-zA-Z-]+)',
  alphanumeric: '([a-zA-Z0-9-]+)'
};

class RootPage extends Component {
  renderPage(component) {
    return <TudoAzulPage>{component}</TudoAzulPage>;
  }

  renderHeader() {
    if (this.props.headerComponentEnabled) {
      return (
        <CookiesProvider>
          <HeaderContainer />
        </CookiesProvider>
      );
    }
  }

  render() {
    return (
      <Router>
        <div>
          {this.renderHeader()}
          <CookiesProvider>
            <span>
              <Switch>
                <Route exact path="/" render={props => this.renderPage(<HomePage {...props} />)} />
                <Route
                  exact
                  path="/searchResult"
                  render={props => this.renderPage(<SearchResultPage {...props} />)}
                />
                <Route
                  exact
                  path="/flightDetails"
                  render={props => this.renderPage(<FlightDetailsPage {...props} />)}
                />
                <Route
                  exact
                  path="/flightChangeSelection"
                  render={props => this.renderPage(<FlightChangeSelection {...props} />)}
                />
                <Route
                  exact
                  path="/flightChange"
                  render={props => this.renderPage(<FlightChangePage {...props} />)}
                />
                <Route
                  exact
                  path="/cancelPnr"
                  render={props => this.renderPage(<CancelPnrPage {...props} />)}
                />
                <Route
                  exact
                  path="/cardCancelPnr"
                  render={props => this.renderPage(<PaymentCancelPage {...props} />)}
                />
                <Route
                  exact
                  path={`/flightChangeSearch/:tripType${regexProps.alpha}/:originJ1${
                    regexProps.alphanumeric
                  }/:destinationJ1${regexProps.alphanumeric}/:originJ2${
                    regexProps.alphanumeric
                  }/:destinationJ2${regexProps.alphanumeric}/:departureDateTime${
                    regexProps.numeric
                  }/:returnDateTime${regexProps.numeric}/:ADT${regexProps.numeric}/:CHD${
                    regexProps.numeric
                  }/:INF${regexProps.numeric}/:SRC${regexProps.numeric}/:YTH${
                    regexProps.numeric
                  }/:searchType${regexProps.alpha}/:flexibilityTravel${
                    regexProps.alpha
                  }/:cabinCategory${regexProps.alpha}/:periodJ1${regexProps.alpha}/:periodJ2${
                    regexProps.alpha
                  }/:locale${regexProps.alpha}/:currency${regexProps.alpha}/:typeOfFlight${
                    regexProps.alpha
                  }/:companiesIdentity${regexProps.alphanumeric}`}
                  render={props => this.renderPage(<FlightChangeSearchPage {...props} />)}
                />
                <Route
                  exact
                  path="/paymentChange"
                  render={props => this.renderPage(<PaymentChangePage {...props} />)}
                />
                {/*Booking flow*/}
                <Route
                  exact
                  path="/flights"
                  render={props => this.renderPage(<FlightsPage {...props} />)}
                />
                <Route
                  exact
                  path={`/flights/:tripType${regexProps.alpha}/:originJ1${
                    regexProps.alphanumeric
                  }/:destinationJ1${regexProps.alphanumeric}/:originJ2${
                    regexProps.alphanumeric
                  }/:destinationJ2${regexProps.alphanumeric}/:departureDateTime${
                    regexProps.numeric
                  }/:returnDateTime${regexProps.numeric}/:ADT${regexProps.numeric}/:CHD${
                    regexProps.numeric
                  }/:INF${regexProps.numeric}/:SRC${regexProps.numeric}/:YTH${
                    regexProps.numeric
                  }/:searchType${regexProps.alpha}/:flexibilityTravel${
                    regexProps.alpha
                  }/:cabinCategory${regexProps.alpha}/:periodJ1${regexProps.alpha}/:periodJ2${
                    regexProps.alpha
                  }/:locale${regexProps.alpha}/:currency${regexProps.alpha}/:typeOfFlight${
                    regexProps.alpha
                  }/:companiesIdentity${regexProps.alphanumeric}`}
                  render={props => this.renderPage(<FlightsSearchPage {...props} />)}
                />
                <Route
                  exact
                  path="/passengers"
                  render={props => this.renderPage(<PassengersPage {...props} />)}
                />
                <Route
                  exact
                  path="/checkout"
                  render={props => this.renderPage(<CheckoutPage {...props} />)}
                />
                <Route
                  exact
                  path="/resume"
                  render={props => this.renderPage(<ResumePage {...props} />)}
                />
                {/* <Route render={props => this.renderPage(<SearchResultPage {...props} />)} /> */}
                <Route render={props => this.renderPage(<HomePage {...props} />)} />
              </Switch>
            </span>
          </CookiesProvider>
        </div>
      </Router>
    );
  }
}

RootPage.defaultProps = defaultProps;
RootPage.propTypes = propTypes;

export default RootPage;



// WEBPACK FOOTER //
// ./src/RootPage.jsx